"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const MonthlyCalendar_1 = require("./MonthlyCalendar");
const MonthlyBody_1 = require("./MonthlyBody");
const format_1 = __importDefault(require("date-fns/format"));
const isToday_1 = __importDefault(require("date-fns/isToday"));
exports.default = ({ isDisabled }) => {
    const calendar = (0, MonthlyCalendar_1.useMonthlyCalendar)();
    let date = (0, MonthlyBody_1.useMonthlyBody)();
    let dayNumber = (0, format_1.default)(date?.day ?? new Date(), "d", {
        locale: calendar?.locale,
    });
    return ((0, jsx_runtime_1.jsx)("div", { "aria-label": `Events for day ${dayNumber}`, className: "h-12 w-12 flex items-center justify-center", children: (0, jsx_runtime_1.jsx)("div", { className: [
                "rounded-full h-9 w-9 flex items-center justify-center",
                (0, isToday_1.default)(date?.day ?? new Date())
                    ? "border border-yellow-700 dark:text-gray-400"
                    : "dark:text-gray-400",
                (0, format_1.default)(date?.day ?? new Date(), "d", { locale: calendar?.locale }) ===
                    (0, format_1.default)(calendar?.date ?? new Date(), "d", {
                        locale: calendar?.locale,
                    })
                    ? "bg-yellow-700 dark:text-gray-800 font-bold"
                    : "",
                date && isDisabled && isDisabled(date.day)
                    ? "text-gray-300 dark:text-gray-600"
                    : "cursor-pointer",
            ].join(" "), onClick: () => calendar && calendar.onCurrentMonthChange(date?.day), children: dayNumber }) }));
};
